  export default[
      {
        path: "/dindvgmryghoiguerygdasdadsdjoidtunfy",
        children: [
          {
            path: "UFWNIUFGTIUVRTEFEWFRFRE8TUREYEOIDYMENE",
            name: "baice25.grades",
            component: () => import("@/views/baice/twf/grades/list.vue"),
            meta: {
              title: "BAICE grade(s)",
              authRequired: true,
              acc: ["y40142"],
            },
          },
          {
            path: "NYHJOFUDIUFYHGECRFEFEREOUUT7YW05UERTUGHTHENTUUT",
            name: "baice25.upload.grades",
            component: () => import("@/views/baice/twf/grades/upload.vue"),
            meta: {
              title: "Upload BAICE Grade(s)",
              authRequired: true,
              acc: ["y81789"],
            },
          },
        //   {
        //     path: "GVNHERREOWHWI5UT0TEYRHRNUNRYTJ3O5UTUYTER",
        //     name: "baice25.update.grades.25",
        //     component: () => import("../views/baice/grades/update.vue"),
        //     meta: {
        //       title: "Update BAICE Grade(s)",
        //       authRequired: true,
        //       acc: ["y41288"],
        //     },
        //   },
          {
            path: "JEBHVRWTHERITITYRTWYWE£DEFE3T8UNYRTHEBERBORWURWRTTERITH",
            name: "baice25.export.grades",
            component: () => import("@/views/baice/twf/grades/export.vue"),
            meta: {
              title: "Export BAICE Grade(s)",
              authRequired: true,
              acc: ["y41288"],
            },
          },
        ],
      },
  ]